import { FC } from "react";

import type { WithdrawalDetails, WithdrawalStatus } from "entities/user";

import { formatAddress, formatAmount, formatDate } from "../../lib";
import { statusStyles, tableStyles } from "../finance-history-table";

interface WithdrawalsTableProps {
  withdrawals: WithdrawalDetails[];
}

const STATUS_LABEL: Record<WithdrawalStatus, string> = {
  in_progress: "In progress",
  completed: "Completed",
  cancelled: "Cancelled",
  rejected: "Rejected",
};

const STATUS_CLASS: Record<WithdrawalStatus, string> = {
  in_progress: statusStyles.statusInProgress,
  completed: statusStyles.statusCompleted,
  cancelled: statusStyles.statusCancelled,
  rejected: statusStyles.statusRejected,
};

const formatTxHash = (withdrawal: WithdrawalDetails): string => {
  if (withdrawal.status !== "completed") {
    return formatAddress(null);
  }

  return formatAddress(withdrawal.completed_tx_hash);
};

export const WithdrawalsTable: FC<WithdrawalsTableProps> = ({
  withdrawals,
}) => {
  if (withdrawals.length === 0) {
    return <p className={tableStyles.empty}>No withdrawals yet</p>;
  }

  return (
    <div className={tableStyles.tableWrap}>
      <table className={tableStyles.table}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Date</th>
            <th>Amount</th>
            <th>Amount (USD)</th>
            <th>Currency</th>
            <th>Network</th>
            <th>Destination Address</th>
            <th>Tx Hash</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {withdrawals.map((withdrawal) => (
            <tr key={withdrawal.id}>
              <td>{withdrawal.id}</td>
              <td>{formatDate(withdrawal.updated_at)}</td>
              <td>{formatAmount(withdrawal.amount)}</td>
              <td>{formatAmount(withdrawal.amount_usdt)}</td>
              <td>{withdrawal.currency.toUpperCase()}</td>
              <td>{withdrawal.network.toUpperCase()}</td>
              <td
                className={tableStyles.truncateCell}
                title={withdrawal.destination_address}
              >
                {formatAddress(withdrawal.destination_address)}
              </td>
              <td
                className={tableStyles.truncateCell}
                title={
                  withdrawal.status === "completed" && withdrawal.completed_tx_hash
                    ? withdrawal.completed_tx_hash
                    : undefined
                }
              >
                {formatTxHash(withdrawal)}
              </td>
              <td className={STATUS_CLASS[withdrawal.status]}>
                {STATUS_LABEL[withdrawal.status]}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
